"use strict";
const config = require('../../../../../config/locales_json/packs/private/users/profile_files.json');
const language = $('body').data("language");
// Class definition

var KTDropzoneDemo = function () {
    // Private functions
    var demo1 = function () {
      var id = '#kt_dropzone_1';
      var myDropzone1 = new Dropzone(id, {
        url: "/usuario/user_files_resume", // Set the url for your upload script location
        paramName: "file", // The name that will be used to transfer the file
        maxFiles: 1,
        maxFilesize: 10, // MB
        addRemoveLinks: true,
        dictRemoveFile: getTranslationValue(config, [language, "dropzone_dictRemoveFile"],"Remover el archivo"),
        acceptedFiles: "application/pdf",
        dictFileTooBig: getTranslationValue(config, [language, "dropzone_dictFileTooBig"],"El archivo supera el límite permitido de {{maxFilesize}}"),
        dictInvalidFileType: getTranslationValue(config, [language, "dropzone_dictInvalidFileType"],"El archivo no es válido, utilizar archivos PDF (.pdf) y documentos de Word (.doc y .docx)"),
        timeout: 90000,
        headers: {
          'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
        },
        accept: function(file, done) {
            if (file.name == "luis_firstjob-copy.jpeg") {
                done("Naha, you don't.");
            } else {
                done();
            }
        }
      });
      myDropzone1.on("success", function(file, response) {
        // var thisProgressBar = id + " .dz-complete";
        setTimeout(function(){
          if ($("button[type='submit']").length > 0){
            $("button[type='submit']").prop('disabled',false);
            $("a.dz-remove").prop('opacity',0);
          }else{
            location.reload();
          }
        }, 300)

      });
    }


    return {
        // public functions
        init: function() {
            demo1();
            // demo2();
            // demo3();
        }
    };
}();
jQuery(document).ready(function() {
  if($("#kt_dropzone_1").length > 0){
    KTDropzoneDemo.init();

    if ($('div#existing_file').length === 0){
      $("button[type='submit']").prop('disabled',true);
    }

    var isMobile = $("#profile-form").hasClass("is_mobile")

    if (isMobile){
      $("button[type='submit']").prop('disabled',false);
    }
  }
})

function getTranslationValue(config, keys, defaultValue) {
	if (keys.length <= 1) return defaultValue;
  
	let currentTranslation;
	let firstIteration = true;
  
	for (let key of keys) {

	  if (firstIteration) {

      if (config[key]) {
        currentTranslation = config[key];
        firstIteration = false;
      } else {
        firstIteration = false;
        return defaultValue;
      }
	  } else {
      
      if (currentTranslation[key]) {
        currentTranslation = currentTranslation[key];
      } else {
        return defaultValue;
      }
	  }
	}
	
	return currentTranslation;
}
